export default __webpack_public_path__ + "static/media/289.b57014b8.png";